<script setup lang="ts">
  import { ColoredButton } from '@/shared/ui';
  import CheckIcon from '@/shared/assets/icons/CheckIcon.svg';

  defineProps<{
    hasFiles: boolean;
    allUploadsComplete: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'confirm'): void;
  }>();
</script>

<template>
  <div
    id="upload-actions-wrapper"
    class="flex justify-end gap-6 pr-4 pb-1.5"
  >
    <ColoredButton
      text="Cancelar"
      icon-alt="Cancelar"
      :outlined="true"
      @click="emit('close')"
    />
    <ColoredButton
      :disabled="!allUploadsComplete"
      disabled-color="light-gray-xx-02"
      text="Salvar"
      icon-alt="Salvar"
      :icon="CheckIcon"
      @click="emit('confirm')"
    />
  </div>
</template>
